import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './themes/ThemeContext';
import WizardSummariesList from './public-forms/WizardSummariesList';
import RuntimeWizardWithBackground from './public-forms/RuntimeWizardWithBackground';
import MySubmissionsPage from './my-submissions/MySubmissionsPage';


function AppAdmin() {
  return (
      <ThemeProvider initialTheme="light">
        <Routes>
          <Route path="/forms" element={<WizardSummariesList />} />
          <Route path="/my-submissions" element={<MySubmissionsPage />} />
          <Route path="/forms/active/:wizardId/:urlSlug" element={<RuntimeWizardWithBackground />} />
          <Route path="/forms/active/:wizardId/:urlSlug/:submissionId" element={<RuntimeWizardWithBackground />} />
          <Route path="*" element={<Navigate to="/forms" replace />} />
        </Routes>
      </ThemeProvider>
  );
}

export default AppAdmin;